package system.single

import com.github.quillraven.fleks.*
import com.soywiz.korge.ui.*
import system.*

class StartCountdownSystem(
    private val textView: UIText
) : IntervalSystem() {

    private var timeAccumulator = 0f

    private var currentStage = INITIAL_DELAY_STAGE

    override fun onTick() {
        when (currentStage) {
            INITIAL_DELAY_STAGE -> {
                if (timeAccumulator >= 1f) {
                    timeAccumulator = 0f
                    currentStage = PREPARE_TEXT_STAGE
                    textView.text = "Приготовься!"
                }
                timeAccumulator += deltaTime
            }

            PREPARE_TEXT_STAGE -> {
                if (timeAccumulator >= 2f) {
                    timeAccumulator = 0f
                    currentStage = COUNTDOWN_STAGE
                }
                timeAccumulator += deltaTime
            }

            COUNTDOWN_STAGE -> {
                if (timeAccumulator > 3) {
                    textView.text = "Вперед!"
                    currentStage = POST_STAGE
                    timeAccumulator = 0f
                    world.system<PlayerControlSystem>().enabled = true
                    return
                }
                if (timeAccumulator < 3) {
                    textView.text = "1"
                }
                if (timeAccumulator < 2) {
                    textView.text = "2"
                }
                if (timeAccumulator < 1) {
                    textView.text = "3"
                }

                timeAccumulator += deltaTime
            }
            POST_STAGE -> {
                if (timeAccumulator < 1f) {
                    timeAccumulator += deltaTime
                } else {
                    textView.visible = false
                    this.enabled = false
                }
            }
        }
    }

    companion object {
        const val INITIAL_DELAY_STAGE = 0
        const val PREPARE_TEXT_STAGE = 1
        const val COUNTDOWN_STAGE = 2
        const val POST_STAGE = 3
    }
}
